<template>
    <div class="wrap btn-position-wrap">
        <div class="client-box">
            <section class="add-user global-section">
                <div class="row">
                    <md-button class="md-icon-button cancel-add-user" @click="cancelEditRelease()">
                        <md-icon>clear</md-icon>
                    </md-button>
                    <div class="col-3">
                        <h2 class="section-title">Edit Version Notes</h2>
                    </div>
                </div>
                <div class="form-error" v-if="formError">{{ formError }}</div>
                <div class="small-box">
                    <div class="row">
                        <div class="col-4">
                            <md-field class="md-block">
                                <md-input :disabled="true" placeholder="Version No." v-model="releaseToEdit.v_no"></md-input>
                            </md-field>
                        </div>
                        <div class="col-4">
                            <md-field class="md-block">{{ releaseToEdit.date }}
                                <datepicker v-show="false" :disabled="true" placeholder="Release Date" v-model="releaseToEdit.date" :format="format"></datepicker>
                            </md-field>
                        </div>
                    </div>
                    <div class="row" v-for="(releasefunction, index) in releaseDetail" :key="index">
                        <div class="col-4">
                            <div class="uploadImgWrapper">
                                <div class="avatar upload s-48 feature-icon-m" style="float:right">
                                    <img src="static/img/settings.svg" alt="feature icon" width="34">
                                </div>
                            </div>
                        </div>
                        <div class="col-7">
                            <div class="textareaWrapper">
                                <md-field class="md-block boder-0">
                                    <textarea class="textareaW" v-model="releasefunction.descriptionVersion" placeholder="Description"></textarea>
                                </md-field>
                                <md-button v-if="hasMultipleRelease" aria-label="Delete Functionality" class="md-icon-button delete-btn " @click="deleteRelease(index)">
                                    <md-icon>delete</md-icon>
                                </md-button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="bottomBtnWrapper">
                                <div class="">
                                    <md-button style="margin-left: 1000px" class="save-user-button md-primary" aria-label="Add New Client" @click="clickSaveNewRelease()">Update</md-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDialog">
            <div class="user-saving-message">
                <span>
                    <md-progress-spinner class="md-accent user-saving-spinner" :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
                     Updating Release...
                </span>
            </div>
        </md-dialog>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import {getReleaseDetail, updateNewRelease} from '../../services/ReleaseService.js';
import Datepicker from 'vuejs-datepicker';

export default {
  data: () => ({
    format: 'MM-dd-yyyy',
    r_no: '',
    r_date: '',
    v_no: '',
    el: '#demo',
    name: 'MultipleSelect',
    formError: null,
    showDialog: false,
    message: '',
    releaseDetail: []
  }),
  components: {
    Datepicker
  },
  computed: {
    ...mapGetters('release', ['releaseToEdit', 'releaseEdited']),
    hasMultipleRelease () {
      return this.releaseDetail.length > 1;
    }
  },
  methods: {
    ...mapActions('user', ['updateUserProfile', 'setReleaseToEdit']),
    cancelEditRelease () {
      this.$router.push('/settings/release');
    },
    deleteRelease (index) {
      if (this.releaseDetail[index].isPrimaryContact) {
        if (index === 0) {
          this.releaseDetail[1].isPrimaryContact = true;
        } else {
          this.releaseDetail[0].isPrimaryContact = true;
        }
      }
      this.releaseDetail.splice(index, 1);
    },
    async loadReleasefunctiondetail (rid) {
      var result = '';
      result = await getReleaseDetail(rid);
      this.releaseDetail = result.data;
    },
    async clickSaveNewRelease () {
      this.showDialog = true;
      if (this.releaseToEdit.r_no === '') {
        this.formError = 'Please enter release number.';
        this.showDialog = false;
      } else if (this.releaseToEdit.date === '') {
        this.formError = 'Please enter release date.';
        this.showDialog = false;
      } else if (this.releaseToEdit.v_no === '') {
        this.formError = 'Please enter version number.';
        this.showDialog = false;
      } else if (this.releaseDetail[0].heading === null || this.releaseDetail[0].description === null) {
        this.formError = 'Please enter release notes.';
        this.showDialog = false;
      } else {
        var newData = {
          r_id: this.releaseToEdit.id,
          r_no: this.releaseToEdit.r_no,
          v_no: this.releaseToEdit.v_no,
          date: this.releaseToEdit.date,
          descriptionVersion: this.releaseToEdit.descriptionVersion,
          functionsDetail: this.releaseDetail
        };
        await updateNewRelease(newData)
          .then(response => {
            this.$router.push('/settings/release');
            this.showDialog = false;
          })
          .catch(error => {
            if (error.response.data.type !== '') {
              this.formError = error.response.data.message;
            }
            this.showDialog = false;
          });
      }
    }
  },
  mounted () {
    this.loadReleasefunctiondetail(this.releaseToEdit.id);
  }
};
</script>
<style lang="scss" scoped>
.save-user-button {
    background-color: #00A8CA;
    font-size: 14px !important;
    font-weight: 500;
}

.new-user-error {
    margin-top: -20px;
    font-size: 11px;
    color: red;
}

.form-error {
    font-size: 15px;
    color: red;
}

.add-button button {
    background-color: #00A8CA !important;
    font-size: 14px !important;
    font-weight: 500 !important;
}

.add-button button:hover {
    background-color: #00788A !important;
}

.client-name-box {
    margin-top: 0 !important;
    padding-top: 0 !important;
}

.add-user.global-section {
    margin-top: 30px;
}

.cancel-add-user {
    float: right;
}

.user-saving-message {
    padding: 10px;
    height: 70px;
    margin: auto;

    .user-saving-spinner {
        margin-right: 20px;
    }
}

.showClientList {
    width: 80%;
    float: left;
    margin-left: 8%;
}

#demo {

    height: 150px;
    overflow: auto;
}

.multiple_select {
    width: 20px;
    min-width: 22px;
    height: 20px;
    position: relative;
    border-radius: 2px;
    border: 2px solid transparent;
    cursor: pointer;
}

.line-itemnew {
    width: 150% !important;
}

.textArea-desc-release {
    width: 150% !important;
    height: 100% !important;
}

.avatar-block .delete-btn {
    position: absolute;
    top: 13px;
    right: -272px;
    opacity: 0;
}

.uploadImgWrapper {
    display: flex;
    align-items: center;
}

.uploadImgWrapper .client-name-box {
    display: flex;
    flex: 0 0 84%;
}

.uploadImgWrapper .avatar.upload.s-48.gray {
    display: flex;
    margin-right: 10px;
    flex: 0 0 48px;
}

.textareaWrapper textarea.textareaW {
    width: 100% !important;
    font-size: 16px;
    font-family: inherit;
}

.md-block.boder-0 {
    border: 0 !important;
}

.textareaWrapper {
    position: relative;
}

.md-icon-button.delete-btn {
    position: absolute;
    right: -60px;
    top: 10px;
}

.bottomBtnWrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.feature-icon-m {
    padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/client/EditReleaseVersion.vue